const Vue = require('vue');

Vue.component('form-required', {
    props: {
        state: {
            type: Boolean,
            default: true
        },
        message: {
            type: String,
            default: 'Obrigatório'
        }
    },
    data() {
        return {}
    },
    ready() {
    },
    template:`
    <i v-if="state"
       v-tooltip
       :vtitle="message"
       class="fa fa-exclamation-circle required-icon"></i>
    `
});



// WEBPACK FOOTER //
// ./resources/assets/javascript/sci/components/form/required.js